import {Pipe, PipeTransform} from '@angular/core';
import {Geometry} from '@turf/helpers';

@Pipe({
    name: 'gndLine'
})
export class GndLinePipe implements PipeTransform {

    transform(geo: Geometry): { lat: number, lng: number }[][] {
        const coordinates = geo.coordinates.map(c => {
            return {lat: c[1], lng: c[0]}
        });
        if (coordinates.length > 1) {
            const toReturn = [];
            for (let i = 0; i < coordinates.length - 1; i += 2) {
                toReturn.push(coordinates.slice(i, i + 2));
            }
            return toReturn;
        }
        return [];
    }

}
